import { AuthService } from './../../core/auth.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  walletBalance = 0;
  userData;
  constructor(private authService: AuthService) {
    //  this.authService.getuserDetails().get().subscribe(data=>{
    //    this.walletBalance = data.data().w;
    //  });
  }

  ngOnInit() {
  }

}
